// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/workflow.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import { file_gitpod_tools_v1_stainless } from "../tools/v1/stainless_pb";
import type { AgentCodeContext, AgentExecution_Status_OutputValue, PullRequest } from "./agent_pb";
import { file_gitpod_v1_agent } from "./agent_pb";
import type { CountRequest, CountResponse } from "./count_pb";
import { file_gitpod_v1_count } from "./count_pb";
import type { Subject } from "./identity_pb";
import { file_gitpod_v1_identity } from "./identity_pb";
import type { PaginationRequest, PaginationResponse, Sort, SortOrder } from "./pagination_pb";
import { file_gitpod_v1_pagination } from "./pagination_pb";
import type { DateRange } from "./usage_pb";
import { file_gitpod_v1_usage } from "./usage_pb";
import type { WorkflowError } from "./workflow_error_pb";
import { file_gitpod_v1_workflow_error } from "./workflow_error_pb";
import type { Duration, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_duration, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/workflow.proto.
 */
export const file_gitpod_v1_workflow: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_tools_v1_stainless, file_gitpod_v1_agent, file_gitpod_v1_count, file_gitpod_v1_identity, file_gitpod_v1_pagination, file_gitpod_v1_usage, file_gitpod_v1_workflow_error, file_google_protobuf_duration, file_google_protobuf_timestamp]);

/**
 * CreateWorkflowRequest creates a new workflow.
 *
 * @generated from message gitpod.v1.CreateWorkflowRequest
 */
export type CreateWorkflowRequest = Message<"gitpod.v1.CreateWorkflowRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: repeated gitpod.v1.WorkflowTrigger triggers = 3;
   */
  triggers: WorkflowTrigger[];

  /**
   * @generated from field: gitpod.v1.WorkflowAction action = 4;
   */
  action?: WorkflowAction;

  /**
   * @generated from field: gitpod.v1.WorkflowAction report = 5;
   */
  report?: WorkflowAction;

  /**
   * Optional executor for the workflow. If not provided, defaults to the creator.
   * Must be either the caller themselves or a service account.
   *
   * @generated from field: optional gitpod.v1.Subject executor = 6;
   */
  executor?: Subject;
};

/**
 * Describes the message gitpod.v1.CreateWorkflowRequest.
 * Use `create(CreateWorkflowRequestSchema)` to create a new message.
 */
export const CreateWorkflowRequestSchema: GenMessage<CreateWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 0);

/**
 * @generated from message gitpod.v1.CreateWorkflowResponse
 */
export type CreateWorkflowResponse = Message<"gitpod.v1.CreateWorkflowResponse"> & {
  /**
   * @generated from field: gitpod.v1.Workflow workflow = 1;
   */
  workflow?: Workflow;
};

/**
 * Describes the message gitpod.v1.CreateWorkflowResponse.
 * Use `create(CreateWorkflowResponseSchema)` to create a new message.
 */
export const CreateWorkflowResponseSchema: GenMessage<CreateWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 1);

/**
 * GetWorkflowRequest gets details about a specific workflow.
 *
 * @generated from message gitpod.v1.GetWorkflowRequest
 */
export type GetWorkflowRequest = Message<"gitpod.v1.GetWorkflowRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message gitpod.v1.GetWorkflowRequest.
 * Use `create(GetWorkflowRequestSchema)` to create a new message.
 */
export const GetWorkflowRequestSchema: GenMessage<GetWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 2);

/**
 * @generated from message gitpod.v1.GetWorkflowResponse
 */
export type GetWorkflowResponse = Message<"gitpod.v1.GetWorkflowResponse"> & {
  /**
   * @generated from field: gitpod.v1.Workflow workflow = 1;
   */
  workflow?: Workflow;
};

/**
 * Describes the message gitpod.v1.GetWorkflowResponse.
 * Use `create(GetWorkflowResponseSchema)` to create a new message.
 */
export const GetWorkflowResponseSchema: GenMessage<GetWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 3);

/**
 * UpdateWorkflowRequest updates a workflow's configuration.
 *
 * @generated from message gitpod.v1.UpdateWorkflowRequest
 */
export type UpdateWorkflowRequest = Message<"gitpod.v1.UpdateWorkflowRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: repeated gitpod.v1.WorkflowTrigger triggers = 4;
   */
  triggers: WorkflowTrigger[];

  /**
   * @generated from field: optional gitpod.v1.WorkflowAction action = 5;
   */
  action?: WorkflowAction;

  /**
   * @generated from field: optional gitpod.v1.WorkflowAction report = 6;
   */
  report?: WorkflowAction;

  /**
   * @generated from field: optional gitpod.v1.Subject executor = 7;
   */
  executor?: Subject;

  /**
   * When set, enables or disables the workflow. A disabled workflow will not
   * be triggered by any automatic trigger and manual starts are rejected.
   *
   * @generated from field: optional bool disabled = 8;
   */
  disabled?: boolean;
};

/**
 * Describes the message gitpod.v1.UpdateWorkflowRequest.
 * Use `create(UpdateWorkflowRequestSchema)` to create a new message.
 */
export const UpdateWorkflowRequestSchema: GenMessage<UpdateWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 4);

/**
 * @generated from message gitpod.v1.UpdateWorkflowResponse
 */
export type UpdateWorkflowResponse = Message<"gitpod.v1.UpdateWorkflowResponse"> & {
  /**
   * @generated from field: gitpod.v1.Workflow workflow = 1;
   */
  workflow?: Workflow;
};

/**
 * Describes the message gitpod.v1.UpdateWorkflowResponse.
 * Use `create(UpdateWorkflowResponseSchema)` to create a new message.
 */
export const UpdateWorkflowResponseSchema: GenMessage<UpdateWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 5);

/**
 * ListWorkflowsRequest lists workflows with optional filtering.
 *
 * @generated from message gitpod.v1.ListWorkflowsRequest
 */
export type ListWorkflowsRequest = Message<"gitpod.v1.ListWorkflowsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListWorkflowsRequest.Filter filter = 2;
   */
  filter?: ListWorkflowsRequest_Filter;

  /**
   * sort specifies the order of results. When unspecified, results are sorted
   * alphabetically by name ascending.
   *
   * @generated from field: gitpod.v1.ListWorkflowsRequest.Sort sort = 3;
   */
  sort?: ListWorkflowsRequest_Sort;

  /**
   * count controls whether the response includes a bounded total count.
   *
   * @generated from field: gitpod.v1.CountRequest count = 4;
   */
  count?: CountRequest;
};

/**
 * Describes the message gitpod.v1.ListWorkflowsRequest.
 * Use `create(ListWorkflowsRequestSchema)` to create a new message.
 */
export const ListWorkflowsRequestSchema: GenMessage<ListWorkflowsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 6);

/**
 * @generated from message gitpod.v1.ListWorkflowsRequest.Filter
 */
export type ListWorkflowsRequest_Filter = Message<"gitpod.v1.ListWorkflowsRequest.Filter"> & {
  /**
   * @generated from field: repeated string workflow_ids = 1;
   */
  workflowIds: string[];

  /**
   * search performs case-insensitive search across workflow name, description, and ID
   *
   * @generated from field: string search = 2;
   */
  search: string;

  /**
   * creator_ids filters workflows by creator user IDs
   *
   * @generated from field: repeated string creator_ids = 3;
   */
  creatorIds: string[];

  /**
   * status_phases filters workflows by the phase of their latest execution.
   * Only workflows whose most recent execution matches one of the specified phases are returned.
   *
   * @generated from field: repeated gitpod.v1.WorkflowExecutionPhase status_phases = 4;
   */
  statusPhases: WorkflowExecutionPhase[];

  /**
   * has_failed_execution_since filters workflows that have at least one failed execution
   * with create_time >= the specified timestamp. A failed execution is one that is COMPLETED
   * with failed_action_count > 0, or STOPPED with failed_action_count > 0 or a non-empty
   * failure_message. This filter is mutually exclusive with status_phases.
   *
   * @generated from field: google.protobuf.Timestamp has_failed_execution_since = 5;
   */
  hasFailedExecutionSince?: Timestamp;

  /**
   * disabled filters workflows by their disabled state.
   * When set to true, only disabled workflows are returned.
   * When set to false, only enabled workflows are returned.
   * When unset, all workflows are returned regardless of disabled state.
   *
   * @generated from field: optional bool disabled = 6;
   */
  disabled?: boolean;
};

/**
 * Describes the message gitpod.v1.ListWorkflowsRequest.Filter.
 * Use `create(ListWorkflowsRequest_FilterSchema)` to create a new message.
 */
export const ListWorkflowsRequest_FilterSchema: GenMessage<ListWorkflowsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 6, 0);

/**
 * @generated from message gitpod.v1.ListWorkflowsRequest.Sort
 */
export type ListWorkflowsRequest_Sort = Message<"gitpod.v1.ListWorkflowsRequest.Sort"> & {
  /**
   * @generated from field: gitpod.v1.ListWorkflowsRequest.SortField field = 1;
   */
  field: ListWorkflowsRequest_SortField;

  /**
   * @generated from field: gitpod.v1.SortOrder order = 2;
   */
  order: SortOrder;
};

/**
 * Describes the message gitpod.v1.ListWorkflowsRequest.Sort.
 * Use `create(ListWorkflowsRequest_SortSchema)` to create a new message.
 */
export const ListWorkflowsRequest_SortSchema: GenMessage<ListWorkflowsRequest_Sort> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 6, 1);

/**
 * @generated from enum gitpod.v1.ListWorkflowsRequest.SortField
 */
export enum ListWorkflowsRequest_SortField {
  /**
   * @generated from enum value: SORT_FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort alphabetically by workflow name.
   *
   * @generated from enum value: SORT_FIELD_NAME = 1;
   */
  NAME = 1,

  /**
   * Sort by the most recent terminal execution's finished_at.
   * Workflows with no executions appear last.
   *
   * @generated from enum value: SORT_FIELD_RECENTLY_COMPLETED = 2;
   */
  RECENTLY_COMPLETED = 2,
}

/**
 * Describes the enum gitpod.v1.ListWorkflowsRequest.SortField.
 */
export const ListWorkflowsRequest_SortFieldSchema: GenEnum<ListWorkflowsRequest_SortField> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_workflow, 6, 0);

/**
 * @generated from message gitpod.v1.ListWorkflowsResponse
 */
export type ListWorkflowsResponse = Message<"gitpod.v1.ListWorkflowsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.Workflow workflows = 2;
   */
  workflows: Workflow[];

  /**
   * count is the bounded total count of matching workflows, present only when
   * requested via CountRequest.include on the first page.
   *
   * @generated from field: gitpod.v1.CountResponse count = 3;
   */
  count?: CountResponse;
};

/**
 * Describes the message gitpod.v1.ListWorkflowsResponse.
 * Use `create(ListWorkflowsResponseSchema)` to create a new message.
 */
export const ListWorkflowsResponseSchema: GenMessage<ListWorkflowsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 7);

/**
 * DeleteWorkflowRequest deletes a workflow permanently.
 *
 * @generated from message gitpod.v1.DeleteWorkflowRequest
 */
export type DeleteWorkflowRequest = Message<"gitpod.v1.DeleteWorkflowRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * force indicates whether to immediately delete the workflow and all related resources.
   * When true, performs cascading deletion of:
   * - All workflow executions
   * - All workflow execution actions
   * - All environments created by workflow actions
   * - All agent executions created by workflow actions
   * - The workflow itself
   * When false (default), marks workflow executions for deletion and relies on
   * background reconciliation to clean up resources.
   *
   * @generated from field: bool force = 2;
   */
  force: boolean;
};

/**
 * Describes the message gitpod.v1.DeleteWorkflowRequest.
 * Use `create(DeleteWorkflowRequestSchema)` to create a new message.
 */
export const DeleteWorkflowRequestSchema: GenMessage<DeleteWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 8);

/**
 * @generated from message gitpod.v1.DeleteWorkflowResponse
 */
export type DeleteWorkflowResponse = Message<"gitpod.v1.DeleteWorkflowResponse"> & {
};

/**
 * Describes the message gitpod.v1.DeleteWorkflowResponse.
 * Use `create(DeleteWorkflowResponseSchema)` to create a new message.
 */
export const DeleteWorkflowResponseSchema: GenMessage<DeleteWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 9);

/**
 * GetWorkflowWebhookSecretRequest retrieves the webhook secret for a workflow.
 *
 * @generated from message gitpod.v1.GetWorkflowWebhookSecretRequest
 */
export type GetWorkflowWebhookSecretRequest = Message<"gitpod.v1.GetWorkflowWebhookSecretRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message gitpod.v1.GetWorkflowWebhookSecretRequest.
 * Use `create(GetWorkflowWebhookSecretRequestSchema)` to create a new message.
 */
export const GetWorkflowWebhookSecretRequestSchema: GenMessage<GetWorkflowWebhookSecretRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 10);

/**
 * @generated from message gitpod.v1.GetWorkflowWebhookSecretResponse
 */
export type GetWorkflowWebhookSecretResponse = Message<"gitpod.v1.GetWorkflowWebhookSecretResponse"> & {
  /**
   * The decrypted webhook secret
   *
   * @generated from field: string secret = 1;
   */
  secret: string;
};

/**
 * Describes the message gitpod.v1.GetWorkflowWebhookSecretResponse.
 * Use `create(GetWorkflowWebhookSecretResponseSchema)` to create a new message.
 */
export const GetWorkflowWebhookSecretResponseSchema: GenMessage<GetWorkflowWebhookSecretResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 11);

/**
 * @generated from message gitpod.v1.RotateWorkflowWebhookSecretRequest
 */
export type RotateWorkflowWebhookSecretRequest = Message<"gitpod.v1.RotateWorkflowWebhookSecretRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;
};

/**
 * Describes the message gitpod.v1.RotateWorkflowWebhookSecretRequest.
 * Use `create(RotateWorkflowWebhookSecretRequestSchema)` to create a new message.
 */
export const RotateWorkflowWebhookSecretRequestSchema: GenMessage<RotateWorkflowWebhookSecretRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 12);

/**
 * @generated from message gitpod.v1.RotateWorkflowWebhookSecretResponse
 */
export type RotateWorkflowWebhookSecretResponse = Message<"gitpod.v1.RotateWorkflowWebhookSecretResponse"> & {
  /**
   * The new webhook secret (decrypted)
   *
   * @generated from field: string secret = 1;
   */
  secret: string;
};

/**
 * Describes the message gitpod.v1.RotateWorkflowWebhookSecretResponse.
 * Use `create(RotateWorkflowWebhookSecretResponseSchema)` to create a new message.
 */
export const RotateWorkflowWebhookSecretResponseSchema: GenMessage<RotateWorkflowWebhookSecretResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 13);

/**
 * StartWorkflowRequest starts a workflow execution.
 *
 * @generated from message gitpod.v1.StartWorkflowRequest
 */
export type StartWorkflowRequest = Message<"gitpod.v1.StartWorkflowRequest"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * Optional context override for the execution.
   * When provided, replaces the workflow's default trigger context.
   * User must have appropriate permissions on the overridden resources.
   * Supports Projects, Repositories, and Agent context types.
   * FromTrigger context type is not supported for manual overrides.
   *
   * @generated from field: optional gitpod.v1.WorkflowTriggerContext context_override = 2;
   */
  contextOverride?: WorkflowTriggerContext;

  /**
   * Parameters to substitute into workflow steps using Go template syntax.
   * Use {{ .Parameters.key_name }} in templatable fields (task.command, agent.prompt,
   * pull_request.title/description/branch, trigger context agent.prompt).
   * Keys must match pattern ^[a-zA-Z_][a-zA-Z0-9_]*$
   * Maximum 10 parameters allowed.
   * Empty map is treated as no parameters provided.
   *
   * @generated from field: map<string, string> parameters = 3;
   */
  parameters: { [key: string]: string };
};

/**
 * Describes the message gitpod.v1.StartWorkflowRequest.
 * Use `create(StartWorkflowRequestSchema)` to create a new message.
 */
export const StartWorkflowRequestSchema: GenMessage<StartWorkflowRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 14);

/**
 * @generated from message gitpod.v1.StartWorkflowResponse
 */
export type StartWorkflowResponse = Message<"gitpod.v1.StartWorkflowResponse"> & {
  /**
   * @generated from field: gitpod.v1.WorkflowExecution workflow_execution = 1;
   */
  workflowExecution?: WorkflowExecution;
};

/**
 * Describes the message gitpod.v1.StartWorkflowResponse.
 * Use `create(StartWorkflowResponseSchema)` to create a new message.
 */
export const StartWorkflowResponseSchema: GenMessage<StartWorkflowResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 15);

/**
 * ListWorkflowExecutionsRequest lists workflow executions with optional filtering.
 *
 * @generated from message gitpod.v1.ListWorkflowExecutionsRequest
 */
export type ListWorkflowExecutionsRequest = Message<"gitpod.v1.ListWorkflowExecutionsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListWorkflowExecutionsRequest.Filter filter = 2;
   */
  filter?: ListWorkflowExecutionsRequest_Filter;

  /**
   * sort specifies the order of results. When unspecified, results are sorted by
   * operational priority (running first, then failed, then completed, then others).
   * Supported sort fields: startedAt, finishedAt, createdAt.
   *
   * @generated from field: gitpod.v1.Sort sort = 3;
   */
  sort?: Sort;
};

/**
 * Describes the message gitpod.v1.ListWorkflowExecutionsRequest.
 * Use `create(ListWorkflowExecutionsRequestSchema)` to create a new message.
 */
export const ListWorkflowExecutionsRequestSchema: GenMessage<ListWorkflowExecutionsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 16);

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionsRequest.Filter
 */
export type ListWorkflowExecutionsRequest_Filter = Message<"gitpod.v1.ListWorkflowExecutionsRequest.Filter"> & {
  /**
   * @generated from field: repeated string workflow_execution_ids = 1;
   */
  workflowExecutionIds: string[];

  /**
   * @generated from field: repeated string workflow_ids = 2;
   */
  workflowIds: string[];

  /**
   * @generated from field: repeated gitpod.v1.WorkflowExecutionPhase status_phases = 3;
   */
  statusPhases: WorkflowExecutionPhase[];

  /**
   * @generated from field: optional bool has_failed_actions = 4;
   */
  hasFailedActions?: boolean;

  /**
   * search performs case-insensitive search across workflow execution ID and trigger type
   *
   * @generated from field: string search = 5;
   */
  search: string;
};

/**
 * Describes the message gitpod.v1.ListWorkflowExecutionsRequest.Filter.
 * Use `create(ListWorkflowExecutionsRequest_FilterSchema)` to create a new message.
 */
export const ListWorkflowExecutionsRequest_FilterSchema: GenMessage<ListWorkflowExecutionsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 16, 0);

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionsResponse
 */
export type ListWorkflowExecutionsResponse = Message<"gitpod.v1.ListWorkflowExecutionsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.WorkflowExecution workflow_executions = 2;
   */
  workflowExecutions: WorkflowExecution[];
};

/**
 * Describes the message gitpod.v1.ListWorkflowExecutionsResponse.
 * Use `create(ListWorkflowExecutionsResponseSchema)` to create a new message.
 */
export const ListWorkflowExecutionsResponseSchema: GenMessage<ListWorkflowExecutionsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 17);

/**
 * GetWorkflowExecutionRequest gets details about a specific workflow execution.
 *
 * @generated from message gitpod.v1.GetWorkflowExecutionRequest
 */
export type GetWorkflowExecutionRequest = Message<"gitpod.v1.GetWorkflowExecutionRequest"> & {
  /**
   * @generated from field: string workflow_execution_id = 1;
   */
  workflowExecutionId: string;
};

/**
 * Describes the message gitpod.v1.GetWorkflowExecutionRequest.
 * Use `create(GetWorkflowExecutionRequestSchema)` to create a new message.
 */
export const GetWorkflowExecutionRequestSchema: GenMessage<GetWorkflowExecutionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 18);

/**
 * @generated from message gitpod.v1.GetWorkflowExecutionResponse
 */
export type GetWorkflowExecutionResponse = Message<"gitpod.v1.GetWorkflowExecutionResponse"> & {
  /**
   * @generated from field: gitpod.v1.WorkflowExecution workflow_execution = 1;
   */
  workflowExecution?: WorkflowExecution;
};

/**
 * Describes the message gitpod.v1.GetWorkflowExecutionResponse.
 * Use `create(GetWorkflowExecutionResponseSchema)` to create a new message.
 */
export const GetWorkflowExecutionResponseSchema: GenMessage<GetWorkflowExecutionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 19);

/**
 * CancelWorkflowExecutionRequest cancels a running workflow execution.
 *
 * @generated from message gitpod.v1.CancelWorkflowExecutionRequest
 */
export type CancelWorkflowExecutionRequest = Message<"gitpod.v1.CancelWorkflowExecutionRequest"> & {
  /**
   * @generated from field: string workflow_execution_id = 1;
   */
  workflowExecutionId: string;
};

/**
 * Describes the message gitpod.v1.CancelWorkflowExecutionRequest.
 * Use `create(CancelWorkflowExecutionRequestSchema)` to create a new message.
 */
export const CancelWorkflowExecutionRequestSchema: GenMessage<CancelWorkflowExecutionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 20);

/**
 * @generated from message gitpod.v1.CancelWorkflowExecutionResponse
 */
export type CancelWorkflowExecutionResponse = Message<"gitpod.v1.CancelWorkflowExecutionResponse"> & {
};

/**
 * Describes the message gitpod.v1.CancelWorkflowExecutionResponse.
 * Use `create(CancelWorkflowExecutionResponseSchema)` to create a new message.
 */
export const CancelWorkflowExecutionResponseSchema: GenMessage<CancelWorkflowExecutionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 21);

/**
 * ListWorkflowExecutionActionsRequest lists workflow execution actions with optional filtering.
 *
 * @generated from message gitpod.v1.ListWorkflowExecutionActionsRequest
 */
export type ListWorkflowExecutionActionsRequest = Message<"gitpod.v1.ListWorkflowExecutionActionsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListWorkflowExecutionActionsRequest.Filter filter = 2;
   */
  filter?: ListWorkflowExecutionActionsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListWorkflowExecutionActionsRequest.
 * Use `create(ListWorkflowExecutionActionsRequestSchema)` to create a new message.
 */
export const ListWorkflowExecutionActionsRequestSchema: GenMessage<ListWorkflowExecutionActionsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 22);

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionActionsRequest.Filter
 */
export type ListWorkflowExecutionActionsRequest_Filter = Message<"gitpod.v1.ListWorkflowExecutionActionsRequest.Filter"> & {
  /**
   * @generated from field: repeated string workflow_execution_action_ids = 1;
   */
  workflowExecutionActionIds: string[];

  /**
   * @generated from field: repeated string workflow_execution_ids = 2;
   */
  workflowExecutionIds: string[];

  /**
   * @generated from field: repeated string workflow_ids = 3;
   */
  workflowIds: string[];

  /**
   * @generated from field: repeated gitpod.v1.WorkflowExecutionActionPhase phases = 4;
   */
  phases: WorkflowExecutionActionPhase[];
};

/**
 * Describes the message gitpod.v1.ListWorkflowExecutionActionsRequest.Filter.
 * Use `create(ListWorkflowExecutionActionsRequest_FilterSchema)` to create a new message.
 */
export const ListWorkflowExecutionActionsRequest_FilterSchema: GenMessage<ListWorkflowExecutionActionsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 22, 0);

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionActionsResponse
 */
export type ListWorkflowExecutionActionsResponse = Message<"gitpod.v1.ListWorkflowExecutionActionsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.WorkflowExecutionAction workflow_execution_actions = 2;
   */
  workflowExecutionActions: WorkflowExecutionAction[];
};

/**
 * Describes the message gitpod.v1.ListWorkflowExecutionActionsResponse.
 * Use `create(ListWorkflowExecutionActionsResponseSchema)` to create a new message.
 */
export const ListWorkflowExecutionActionsResponseSchema: GenMessage<ListWorkflowExecutionActionsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 23);

/**
 * GetWorkflowExecutionActionRequest gets details about a specific workflow execution action.
 *
 * @generated from message gitpod.v1.GetWorkflowExecutionActionRequest
 */
export type GetWorkflowExecutionActionRequest = Message<"gitpod.v1.GetWorkflowExecutionActionRequest"> & {
  /**
   * @generated from field: string workflow_execution_action_id = 1;
   */
  workflowExecutionActionId: string;
};

/**
 * Describes the message gitpod.v1.GetWorkflowExecutionActionRequest.
 * Use `create(GetWorkflowExecutionActionRequestSchema)` to create a new message.
 */
export const GetWorkflowExecutionActionRequestSchema: GenMessage<GetWorkflowExecutionActionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 24);

/**
 * @generated from message gitpod.v1.GetWorkflowExecutionActionResponse
 */
export type GetWorkflowExecutionActionResponse = Message<"gitpod.v1.GetWorkflowExecutionActionResponse"> & {
  /**
   * @generated from field: gitpod.v1.WorkflowExecutionAction workflow_execution_action = 1;
   */
  workflowExecutionAction?: WorkflowExecutionAction;
};

/**
 * Describes the message gitpod.v1.GetWorkflowExecutionActionResponse.
 * Use `create(GetWorkflowExecutionActionResponseSchema)` to create a new message.
 */
export const GetWorkflowExecutionActionResponseSchema: GenMessage<GetWorkflowExecutionActionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 25);

/**
 * CancelWorkflowExecutionActionRequest cancels a running workflow execution action.
 *
 * @generated from message gitpod.v1.CancelWorkflowExecutionActionRequest
 */
export type CancelWorkflowExecutionActionRequest = Message<"gitpod.v1.CancelWorkflowExecutionActionRequest"> & {
  /**
   * @generated from field: string workflow_execution_action_id = 1;
   */
  workflowExecutionActionId: string;
};

/**
 * Describes the message gitpod.v1.CancelWorkflowExecutionActionRequest.
 * Use `create(CancelWorkflowExecutionActionRequestSchema)` to create a new message.
 */
export const CancelWorkflowExecutionActionRequestSchema: GenMessage<CancelWorkflowExecutionActionRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 26);

/**
 * @generated from message gitpod.v1.CancelWorkflowExecutionActionResponse
 */
export type CancelWorkflowExecutionActionResponse = Message<"gitpod.v1.CancelWorkflowExecutionActionResponse"> & {
};

/**
 * Describes the message gitpod.v1.CancelWorkflowExecutionActionResponse.
 * Use `create(CancelWorkflowExecutionActionResponseSchema)` to create a new message.
 */
export const CancelWorkflowExecutionActionResponseSchema: GenMessage<CancelWorkflowExecutionActionResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 27);

/**
 * Workflow represents a workflow configuration.
 *
 * @generated from message gitpod.v1.Workflow
 */
export type Workflow = Message<"gitpod.v1.Workflow"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: gitpod.v1.Workflow.Metadata metadata = 2;
   */
  metadata?: Workflow_Metadata;

  /**
   * @generated from field: gitpod.v1.Workflow.Spec spec = 3;
   */
  spec?: Workflow_Spec;

  /**
   * Webhook URL for triggering this workflow via HTTP POST
   * Format: {base_url}/workflows/{workflow_id}/webhooks
   *
   * @generated from field: string webhook_url = 4;
   */
  webhookUrl: string;
};

/**
 * Describes the message gitpod.v1.Workflow.
 * Use `create(WorkflowSchema)` to create a new message.
 */
export const WorkflowSchema: GenMessage<Workflow> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 28);

/**
 * WorkflowMetadata contains workflow metadata.
 *
 * @generated from message gitpod.v1.Workflow.Metadata
 */
export type Workflow_Metadata = Message<"gitpod.v1.Workflow.Metadata"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: gitpod.v1.Subject creator = 3;
   */
  creator?: Subject;

  /**
   * @generated from field: gitpod.v1.Subject executor = 6;
   */
  executor?: Subject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.Workflow.Metadata.
 * Use `create(Workflow_MetadataSchema)` to create a new message.
 */
export const Workflow_MetadataSchema: GenMessage<Workflow_Metadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 28, 0);

/**
 * @generated from message gitpod.v1.Workflow.Spec
 */
export type Workflow_Spec = Message<"gitpod.v1.Workflow.Spec"> & {
  /**
   * @generated from field: repeated gitpod.v1.WorkflowTrigger triggers = 3;
   */
  triggers: WorkflowTrigger[];

  /**
   * @generated from field: gitpod.v1.WorkflowAction action = 4;
   */
  action?: WorkflowAction;

  /**
   * @generated from field: gitpod.v1.WorkflowAction report = 5;
   */
  report?: WorkflowAction;

  /**
   * Marks workflow as pending deletion
   *
   * @generated from field: bool deleting = 6;
   */
  deleting: boolean;

  /**
   * When true, the workflow will not be triggered by any automatic trigger
   * (cron, webhook, pull request). Manual starts via StartWorkflow are also
   * rejected while disabled.
   *
   * @generated from field: bool disabled = 7;
   */
  disabled: boolean;
};

/**
 * Describes the message gitpod.v1.Workflow.Spec.
 * Use `create(Workflow_SpecSchema)` to create a new message.
 */
export const Workflow_SpecSchema: GenMessage<Workflow_Spec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 28, 1);

/**
 * WorkflowTrigger defines when a workflow should be executed.
 *
 * Each trigger type defines a specific condition that will cause the workflow to execute:
 * - Manual: Triggered explicitly by user action via StartWorkflow RPC
 * - Time: Triggered automatically based on cron schedule
 * - PullRequest: Triggered automatically when specified PR events occur
 *
 * Trigger Semantics:
 * - Each trigger instance can create multiple workflow executions
 * - Multiple triggers of the same workflow can fire simultaneously
 * - Each trigger execution is independent and tracked separately
 * - Triggers are evaluated in the context specified by WorkflowTriggerContext
 *
 * @generated from message gitpod.v1.WorkflowTrigger
 */
export type WorkflowTrigger = Message<"gitpod.v1.WorkflowTrigger"> & {
  /**
   * @generated from oneof gitpod.v1.WorkflowTrigger.trigger
   */
  trigger: {
    /**
     * @generated from field: gitpod.v1.WorkflowTrigger.Manual manual = 1;
     */
    value: WorkflowTrigger_Manual;
    case: "manual";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTrigger.Time time = 2;
     */
    value: WorkflowTrigger_Time;
    case: "time";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTrigger.PullRequest pull_request = 3;
     */
    value: WorkflowTrigger_PullRequest;
    case: "pullRequest";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: gitpod.v1.WorkflowTriggerContext context = 4;
   */
  context?: WorkflowTriggerContext;
};

/**
 * Describes the message gitpod.v1.WorkflowTrigger.
 * Use `create(WorkflowTriggerSchema)` to create a new message.
 */
export const WorkflowTriggerSchema: GenMessage<WorkflowTrigger> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 29);

/**
 * Manual trigger - executed when StartWorkflow RPC is called.
 * No additional configuration needed.
 *
 * @generated from message gitpod.v1.WorkflowTrigger.Manual
 */
export type WorkflowTrigger_Manual = Message<"gitpod.v1.WorkflowTrigger.Manual"> & {
};

/**
 * Describes the message gitpod.v1.WorkflowTrigger.Manual.
 * Use `create(WorkflowTrigger_ManualSchema)` to create a new message.
 */
export const WorkflowTrigger_ManualSchema: GenMessage<WorkflowTrigger_Manual> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 29, 0);

/**
 * Time-based trigger - executed automatically based on cron schedule.
 * Uses standard cron expression format (minute hour day month weekday).
 *
 * @generated from message gitpod.v1.WorkflowTrigger.Time
 */
export type WorkflowTrigger_Time = Message<"gitpod.v1.WorkflowTrigger.Time"> & {
  /**
   * @generated from field: string cron_expression = 1;
   */
  cronExpression: string;
};

/**
 * Describes the message gitpod.v1.WorkflowTrigger.Time.
 * Use `create(WorkflowTrigger_TimeSchema)` to create a new message.
 */
export const WorkflowTrigger_TimeSchema: GenMessage<WorkflowTrigger_Time> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 29, 1);

/**
 * Pull request trigger - executed when specified PR events occur.
 * Only triggers for PRs in repositories matching the trigger context.
 *
 * @generated from message gitpod.v1.WorkflowTrigger.PullRequest
 */
export type WorkflowTrigger_PullRequest = Message<"gitpod.v1.WorkflowTrigger.PullRequest"> & {
  /**
   * @generated from field: repeated gitpod.v1.WorkflowTrigger.PullRequestEvent events = 1;
   */
  events: WorkflowTrigger_PullRequestEvent[];

  /**
   * webhook_id is the optional ID of a webhook that this trigger is bound to.
   * When set, the trigger will be activated when the webhook receives events.
   * This allows multiple workflows to share a single webhook endpoint.
   *
   * @generated from field: optional string webhook_id = 2;
   */
  webhookId?: string;

  /**
   * integration_id is the optional ID of an integration that acts as the source of webhook events.
   * When set, the trigger will be activated when the webhook receives events.
   *
   * @generated from field: optional string integration_id = 3;
   */
  integrationId?: string;
};

/**
 * Describes the message gitpod.v1.WorkflowTrigger.PullRequest.
 * Use `create(WorkflowTrigger_PullRequestSchema)` to create a new message.
 */
export const WorkflowTrigger_PullRequestSchema: GenMessage<WorkflowTrigger_PullRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 29, 2);

/**
 * WorkflowPREvent defines pull request events that can trigger workflows.
 *
 * @generated from enum gitpod.v1.WorkflowTrigger.PullRequestEvent
 */
export enum WorkflowTrigger_PullRequestEvent {
  /**
   * @generated from enum value: PULL_REQUEST_EVENT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_OPENED = 1;
   */
  OPENED = 1,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_UPDATED = 2;
   */
  UPDATED = 2,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_APPROVED = 3;
   */
  APPROVED = 3,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_MERGED = 4;
   */
  MERGED = 4,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_CLOSED = 5;
   */
  CLOSED = 5,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_READY_FOR_REVIEW = 6;
   */
  READY_FOR_REVIEW = 6,

  /**
   * @generated from enum value: PULL_REQUEST_EVENT_REVIEW_REQUESTED = 7;
   */
  REVIEW_REQUESTED = 7,
}

/**
 * Describes the enum gitpod.v1.WorkflowTrigger.PullRequestEvent.
 */
export const WorkflowTrigger_PullRequestEventSchema: GenEnum<WorkflowTrigger_PullRequestEvent> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_workflow, 29, 0);

/**
 * WorkflowTriggerContext defines the context in which a workflow should run.
 *
 * Context determines where and how the workflow executes:
 * - Projects: Execute in specific project environments
 * - Repositories: Execute in environments created from repository URLs
 * - Agent: Execute in agent-managed environments with custom prompts
 * - FromTrigger: Use context derived from the trigger event (PR-specific)
 *
 * Context Usage by Trigger Type:
 * - Manual: Can use any context type
 * - Time: Typically uses Projects or Repositories context
 * - PullRequest: Can use any context, FromTrigger uses PR repository context
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext
 */
export type WorkflowTriggerContext = Message<"gitpod.v1.WorkflowTriggerContext"> & {
  /**
   * @generated from oneof gitpod.v1.WorkflowTriggerContext.context
   */
  context: {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.Projects projects = 1;
     */
    value: WorkflowTriggerContext_Projects;
    case: "projects";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.Repositories repositories = 2;
     */
    value: WorkflowTriggerContext_Repositories;
    case: "repositories";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.Agent agent = 3;
     */
    value: WorkflowTriggerContext_Agent;
    case: "agent";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.FromTrigger from_trigger = 4;
     */
    value: WorkflowTriggerContext_FromTrigger;
    case: "fromTrigger";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.WorkflowTriggerContext.
 * Use `create(WorkflowTriggerContextSchema)` to create a new message.
 */
export const WorkflowTriggerContextSchema: GenMessage<WorkflowTriggerContext> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 30);

/**
 * Execute workflow in specific project environments.
 * Creates environments for each specified project.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.Projects
 */
export type WorkflowTriggerContext_Projects = Message<"gitpod.v1.WorkflowTriggerContext.Projects"> & {
  /**
   * @generated from field: repeated string project_ids = 1;
   */
  projectIds: string[];
};

/**
 * Describes the message gitpod.v1.WorkflowTriggerContext.Projects.
 * Use `create(WorkflowTriggerContext_ProjectsSchema)` to create a new message.
 */
export const WorkflowTriggerContext_ProjectsSchema: GenMessage<WorkflowTriggerContext_Projects> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 30, 0);

/**
 * Execute workflow in environments created from repository URLs.
 * Supports both explicit repository URLs and search patterns.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.Repositories
 */
export type WorkflowTriggerContext_Repositories = Message<"gitpod.v1.WorkflowTriggerContext.Repositories"> & {
  /**
   * @generated from oneof gitpod.v1.WorkflowTriggerContext.Repositories.repository_selector
   */
  repositorySelector: {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.Repositories.RepositoryURLs repository_urls = 1;
     */
    value: WorkflowTriggerContext_Repositories_RepositoryURLs;
    case: "repositoryUrls";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowTriggerContext.Repositories.RepositorySelector repo_selector = 2;
     */
    value: WorkflowTriggerContext_Repositories_RepositorySelector;
    case: "repoSelector";
  } | { case: undefined; value?: undefined };

  /**
   * @generated from field: string environment_class_id = 3;
   */
  environmentClassId: string;
};

/**
 * Describes the message gitpod.v1.WorkflowTriggerContext.Repositories.
 * Use `create(WorkflowTriggerContext_RepositoriesSchema)` to create a new message.
 */
export const WorkflowTriggerContext_RepositoriesSchema: GenMessage<WorkflowTriggerContext_Repositories> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 30, 1);

/**
 * RepositoryURLs contains a list of explicit repository URLs.
 * Creates one action per repository URL.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.Repositories.RepositoryURLs
 */
export type WorkflowTriggerContext_Repositories_RepositoryURLs = Message<"gitpod.v1.WorkflowTriggerContext.Repositories.RepositoryURLs"> & {
  /**
   * @generated from field: repeated string repo_urls = 1;
   */
  repoUrls: string[];
};

/**
 * Describes the message gitpod.v1.WorkflowTriggerContext.Repositories.RepositoryURLs.
 * Use `create(WorkflowTriggerContext_Repositories_RepositoryURLsSchema)` to create a new message.
 */
export const WorkflowTriggerContext_Repositories_RepositoryURLsSchema: GenMessage<WorkflowTriggerContext_Repositories_RepositoryURLs> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 30, 1, 0);

/**
 * RepositorySelector defines how to select repositories for workflow execution.
 * Combines a search string with an SCM host to identify repositories.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.Repositories.RepositorySelector
 */
export type WorkflowTriggerContext_Repositories_RepositorySelector = Message<"gitpod.v1.WorkflowTriggerContext.Repositories.RepositorySelector"> & {
  /**
   * Search string to match repositories using SCM-specific search patterns.
   * For GitHub: supports GitHub search syntax (e.g., "org:gitpod-io language:go", "user:octocat stars:>100")
   * For GitLab: supports GitLab search syntax
   * See SCM provider documentation for supported search patterns.
   *
   * @generated from field: string repo_search_string = 1;
   */
  repoSearchString: string;

  /**
   * SCM host where the search should be performed (e.g., "github.com", "gitlab.com")
   *
   * @generated from field: string scm_host = 2;
   */
  scmHost: string;
};

/**
 * Describes the message gitpod.v1.WorkflowTriggerContext.Repositories.RepositorySelector.
 * Use `create(WorkflowTriggerContext_Repositories_RepositorySelectorSchema)` to create a new message.
 */
export const WorkflowTriggerContext_Repositories_RepositorySelectorSchema: GenMessage<WorkflowTriggerContext_Repositories_RepositorySelector> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 30, 1, 1);

/**
 * Execute workflow in agent-managed environments.
 * Agent receives the specified prompt and manages execution context.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.Agent
 */
export type WorkflowTriggerContext_Agent = Message<"gitpod.v1.WorkflowTriggerContext.Agent"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;
};

/**
 * Describes the message gitpod.v1.WorkflowTriggerContext.Agent.
 * Use `create(WorkflowTriggerContext_AgentSchema)` to create a new message.
 */
export const WorkflowTriggerContext_AgentSchema: GenMessage<WorkflowTriggerContext_Agent> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 30, 2);

/**
 * Use context derived from the trigger event.
 * Currently only supported for PullRequest triggers - uses PR repository context.
 *
 * @generated from message gitpod.v1.WorkflowTriggerContext.FromTrigger
 */
export type WorkflowTriggerContext_FromTrigger = Message<"gitpod.v1.WorkflowTriggerContext.FromTrigger"> & {
};

/**
 * Describes the message gitpod.v1.WorkflowTriggerContext.FromTrigger.
 * Use `create(WorkflowTriggerContext_FromTriggerSchema)` to create a new message.
 */
export const WorkflowTriggerContext_FromTriggerSchema: GenMessage<WorkflowTriggerContext_FromTrigger> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 30, 3);

/**
 * WorkflowAction defines the actions to be executed in a workflow.
 *
 * @generated from message gitpod.v1.WorkflowAction
 */
export type WorkflowAction = Message<"gitpod.v1.WorkflowAction"> & {
  /**
   * @generated from field: gitpod.v1.WorkflowAction.Limits limits = 1;
   */
  limits?: WorkflowAction_Limits;

  /**
   * @generated from field: repeated gitpod.v1.WorkflowStep steps = 2;
   */
  steps: WorkflowStep[];
};

/**
 * Describes the message gitpod.v1.WorkflowAction.
 * Use `create(WorkflowActionSchema)` to create a new message.
 */
export const WorkflowActionSchema: GenMessage<WorkflowAction> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 31);

/**
 * Limits defines execution limits for workflow actions.
 *
 * @generated from message gitpod.v1.WorkflowAction.Limits
 */
export type WorkflowAction_Limits = Message<"gitpod.v1.WorkflowAction.Limits"> & {
  /**
   * @generated from field: int32 max_parallel = 1;
   */
  maxParallel: number;

  /**
   * @generated from field: int32 max_total = 2;
   */
  maxTotal: number;

  /**
   * @generated from field: gitpod.v1.WorkflowAction.Limits.PerExecution per_execution = 3;
   */
  perExecution?: WorkflowAction_Limits_PerExecution;
};

/**
 * Describes the message gitpod.v1.WorkflowAction.Limits.
 * Use `create(WorkflowAction_LimitsSchema)` to create a new message.
 */
export const WorkflowAction_LimitsSchema: GenMessage<WorkflowAction_Limits> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 31, 0);

/**
 * PerExecution defines limits per execution action.
 *
 * @generated from message gitpod.v1.WorkflowAction.Limits.PerExecution
 */
export type WorkflowAction_Limits_PerExecution = Message<"gitpod.v1.WorkflowAction.Limits.PerExecution"> & {
  /**
   * Maximum time allowed for a single execution action.
   * Use standard duration format (e.g., "30m" for 30 minutes, "2h" for 2 hours).
   *
   * @generated from field: google.protobuf.Duration max_time = 1;
   */
  maxTime?: Duration;
};

/**
 * Describes the message gitpod.v1.WorkflowAction.Limits.PerExecution.
 * Use `create(WorkflowAction_Limits_PerExecutionSchema)` to create a new message.
 */
export const WorkflowAction_Limits_PerExecutionSchema: GenMessage<WorkflowAction_Limits_PerExecution> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 31, 0, 0);

/**
 * WorkflowStep defines a single step in a workflow action.
 *
 * @generated from message gitpod.v1.WorkflowStep
 */
export type WorkflowStep = Message<"gitpod.v1.WorkflowStep"> & {
  /**
   * @generated from oneof gitpod.v1.WorkflowStep.step
   */
  step: {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Task task = 1;
     */
    value: WorkflowStep_Task;
    case: "task";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Agent agent = 2;
     */
    value: WorkflowStep_Agent;
    case: "agent";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.PullRequest pull_request = 3;
     */
    value: WorkflowStep_PullRequest;
    case: "pullRequest";
  } | {
    /**
     * Skipped from SDK: OutputSpec's two oneof fields produce an allOf in the OpenAPI spec,
     * which Stainless's Python codegen cannot handle (generates empty classes)
     *
     * @generated from field: gitpod.v1.WorkflowStep.Report report = 4;
     */
    value: WorkflowStep_Report;
    case: "report";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.WorkflowStep.
 * Use `create(WorkflowStepSchema)` to create a new message.
 */
export const WorkflowStepSchema: GenMessage<WorkflowStep> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 32);

/**
 * WorkflowTaskStep represents a task step that executes a command.
 *
 * @generated from message gitpod.v1.WorkflowStep.Task
 */
export type WorkflowStep_Task = Message<"gitpod.v1.WorkflowStep.Task"> & {
  /**
   * @generated from field: string command = 1;
   */
  command: string;
};

/**
 * Describes the message gitpod.v1.WorkflowStep.Task.
 * Use `create(WorkflowStep_TaskSchema)` to create a new message.
 */
export const WorkflowStep_TaskSchema: GenMessage<WorkflowStep_Task> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 32, 0);

/**
 * WorkflowAgentStep represents an agent step that executes with a prompt.
 *
 * @generated from message gitpod.v1.WorkflowStep.Agent
 */
export type WorkflowStep_Agent = Message<"gitpod.v1.WorkflowStep.Agent"> & {
  /**
   * @generated from field: string prompt = 1;
   */
  prompt: string;
};

/**
 * Describes the message gitpod.v1.WorkflowStep.Agent.
 * Use `create(WorkflowStep_AgentSchema)` to create a new message.
 */
export const WorkflowStep_AgentSchema: GenMessage<WorkflowStep_Agent> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 32, 1);

/**
 * WorkflowPullRequestStep represents a pull request creation step.
 *
 * @generated from message gitpod.v1.WorkflowStep.PullRequest
 */
export type WorkflowStep_PullRequest = Message<"gitpod.v1.WorkflowStep.PullRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * @generated from field: string branch = 3;
   */
  branch: string;

  /**
   * @generated from field: bool draft = 4;
   */
  draft: boolean;
};

/**
 * Describes the message gitpod.v1.WorkflowStep.PullRequest.
 * Use `create(WorkflowStep_PullRequestSchema)` to create a new message.
 */
export const WorkflowStep_PullRequestSchema: GenMessage<WorkflowStep_PullRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 32, 2);

/**
 * @generated from message gitpod.v1.WorkflowStep.Report
 */
export type WorkflowStep_Report = Message<"gitpod.v1.WorkflowStep.Report"> & {
  /**
   * @generated from field: repeated gitpod.v1.WorkflowStep.Report.OutputSpec outputs = 1;
   */
  outputs: WorkflowStep_Report_OutputSpec[];
};

/**
 * Describes the message gitpod.v1.WorkflowStep.Report.
 * Use `create(WorkflowStep_ReportSchema)` to create a new message.
 */
export const WorkflowStep_ReportSchema: GenMessage<WorkflowStep_Report> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 32, 3);

/**
 * @generated from message gitpod.v1.WorkflowStep.Report.StringSchema
 */
export type WorkflowStep_Report_StringSchema = Message<"gitpod.v1.WorkflowStep.Report.StringSchema"> & {
  /**
   * @generated from field: string pattern = 1;
   */
  pattern: string;
};

/**
 * Describes the message gitpod.v1.WorkflowStep.Report.StringSchema.
 * Use `create(WorkflowStep_Report_StringSchemaSchema)` to create a new message.
 */
export const WorkflowStep_Report_StringSchemaSchema: GenMessage<WorkflowStep_Report_StringSchema> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 32, 3, 0);

/**
 * @generated from message gitpod.v1.WorkflowStep.Report.IntegerSchema
 */
export type WorkflowStep_Report_IntegerSchema = Message<"gitpod.v1.WorkflowStep.Report.IntegerSchema"> & {
  /**
   * @generated from field: optional int32 min = 1;
   */
  min?: number;

  /**
   * @generated from field: optional int32 max = 2;
   */
  max?: number;
};

/**
 * Describes the message gitpod.v1.WorkflowStep.Report.IntegerSchema.
 * Use `create(WorkflowStep_Report_IntegerSchemaSchema)` to create a new message.
 */
export const WorkflowStep_Report_IntegerSchemaSchema: GenMessage<WorkflowStep_Report_IntegerSchema> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 32, 3, 1);

/**
 * @generated from message gitpod.v1.WorkflowStep.Report.FloatSchema
 */
export type WorkflowStep_Report_FloatSchema = Message<"gitpod.v1.WorkflowStep.Report.FloatSchema"> & {
  /**
   * @generated from field: optional float min = 1;
   */
  min?: number;

  /**
   * @generated from field: optional float max = 2;
   */
  max?: number;
};

/**
 * Describes the message gitpod.v1.WorkflowStep.Report.FloatSchema.
 * Use `create(WorkflowStep_Report_FloatSchemaSchema)` to create a new message.
 */
export const WorkflowStep_Report_FloatSchemaSchema: GenMessage<WorkflowStep_Report_FloatSchema> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 32, 3, 2);

/**
 * @generated from message gitpod.v1.WorkflowStep.Report.BooleanSchema
 */
export type WorkflowStep_Report_BooleanSchema = Message<"gitpod.v1.WorkflowStep.Report.BooleanSchema"> & {
};

/**
 * Describes the message gitpod.v1.WorkflowStep.Report.BooleanSchema.
 * Use `create(WorkflowStep_Report_BooleanSchemaSchema)` to create a new message.
 */
export const WorkflowStep_Report_BooleanSchemaSchema: GenMessage<WorkflowStep_Report_BooleanSchema> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 32, 3, 3);

/**
 * @generated from message gitpod.v1.WorkflowStep.Report.OutputSpec
 */
export type WorkflowStep_Report_OutputSpec = Message<"gitpod.v1.WorkflowStep.Report.OutputSpec"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string key = 2;
   */
  key: string;

  /**
   * @generated from oneof gitpod.v1.WorkflowStep.Report.OutputSpec.schema
   */
  schema: {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Report.StringSchema string = 10;
     */
    value: WorkflowStep_Report_StringSchema;
    case: "string";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Report.IntegerSchema integer = 11;
     */
    value: WorkflowStep_Report_IntegerSchema;
    case: "integer";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Report.FloatSchema float = 12;
     */
    value: WorkflowStep_Report_FloatSchema;
    case: "float";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowStep.Report.BooleanSchema boolean = 13;
     */
    value: WorkflowStep_Report_BooleanSchema;
    case: "boolean";
  } | { case: undefined; value?: undefined };

  /**
   * Optional CEL expression that decides if the value is acceptable,
   * e.g. is the test coverage high enough. Has one variable (value), must eval to boolean.
   *
   * @generated from field: optional string acceptance_criteria = 5;
   */
  acceptanceCriteria?: string;

  /**
   * @generated from oneof gitpod.v1.WorkflowStep.Report.OutputSpec.extraction
   */
  extraction: {
    /**
     * @generated from field: string prompt = 20;
     */
    value: string;
    case: "prompt";
  } | {
    /**
     * @generated from field: string command = 21;
     */
    value: string;
    case: "command";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gitpod.v1.WorkflowStep.Report.OutputSpec.
 * Use `create(WorkflowStep_Report_OutputSpecSchema)` to create a new message.
 */
export const WorkflowStep_Report_OutputSpecSchema: GenMessage<WorkflowStep_Report_OutputSpec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 32, 3, 4);

/**
 * WorkflowExecutionTrigger represents a workflow execution trigger instance.
 *
 * @generated from message gitpod.v1.WorkflowExecutionTrigger
 */
export type WorkflowExecutionTrigger = Message<"gitpod.v1.WorkflowExecutionTrigger"> & {
  /**
   * @generated from oneof gitpod.v1.WorkflowExecutionTrigger.trigger
   */
  trigger: {
    /**
     * @generated from field: gitpod.v1.WorkflowExecutionTrigger.Manual manual = 1;
     */
    value: WorkflowExecutionTrigger_Manual;
    case: "manual";
  } | {
    /**
     * @generated from field: gitpod.v1.WorkflowExecutionTrigger.Time time = 2;
     */
    value: WorkflowExecutionTrigger_Time;
    case: "time";
  } | {
    /**
     * @generated from field: gitpod.v1.PullRequest pull_request = 3;
     */
    value: PullRequest;
    case: "pullRequest";
  } | { case: undefined; value?: undefined };

  /**
   * Context from the workflow trigger - copied at execution time for immutability.
   * This allows the reconciler to create actions without fetching the workflow definition.
   *
   * @generated from field: gitpod.v1.WorkflowTriggerContext context = 4;
   */
  context?: WorkflowTriggerContext;
};

/**
 * Describes the message gitpod.v1.WorkflowExecutionTrigger.
 * Use `create(WorkflowExecutionTriggerSchema)` to create a new message.
 */
export const WorkflowExecutionTriggerSchema: GenMessage<WorkflowExecutionTrigger> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 33);

/**
 * Manual trigger - empty message since no additional data needed
 *
 * @generated from message gitpod.v1.WorkflowExecutionTrigger.Manual
 */
export type WorkflowExecutionTrigger_Manual = Message<"gitpod.v1.WorkflowExecutionTrigger.Manual"> & {
};

/**
 * Describes the message gitpod.v1.WorkflowExecutionTrigger.Manual.
 * Use `create(WorkflowExecutionTrigger_ManualSchema)` to create a new message.
 */
export const WorkflowExecutionTrigger_ManualSchema: GenMessage<WorkflowExecutionTrigger_Manual> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 33, 0);

/**
 * Time trigger - just the timestamp when it was triggered
 *
 * @generated from message gitpod.v1.WorkflowExecutionTrigger.Time
 */
export type WorkflowExecutionTrigger_Time = Message<"gitpod.v1.WorkflowExecutionTrigger.Time"> & {
  /**
   * @generated from field: google.protobuf.Timestamp triggered_at = 1;
   */
  triggeredAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.WorkflowExecutionTrigger.Time.
 * Use `create(WorkflowExecutionTrigger_TimeSchema)` to create a new message.
 */
export const WorkflowExecutionTrigger_TimeSchema: GenMessage<WorkflowExecutionTrigger_Time> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 33, 1);

/**
 * WorkflowExecution represents a workflow execution instance.
 *
 * @generated from message gitpod.v1.WorkflowExecution
 */
export type WorkflowExecution = Message<"gitpod.v1.WorkflowExecution"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: gitpod.v1.WorkflowExecution.Metadata metadata = 2;
   */
  metadata?: WorkflowExecution_Metadata;

  /**
   * @generated from field: gitpod.v1.WorkflowExecution.Spec spec = 3;
   */
  spec?: WorkflowExecution_Spec;

  /**
   * @generated from field: gitpod.v1.WorkflowExecution.Status status = 4;
   */
  status?: WorkflowExecution_Status;
};

/**
 * Describes the message gitpod.v1.WorkflowExecution.
 * Use `create(WorkflowExecutionSchema)` to create a new message.
 */
export const WorkflowExecutionSchema: GenMessage<WorkflowExecution> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 34);

/**
 * WorkflowExecutionMetadata contains workflow execution metadata.
 *
 * @generated from message gitpod.v1.WorkflowExecution.Metadata
 */
export type WorkflowExecution_Metadata = Message<"gitpod.v1.WorkflowExecution.Metadata"> & {
  /**
   * @generated from field: string workflow_id = 1;
   */
  workflowId: string;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 2;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 3;
   */
  finishedAt?: Timestamp;

  /**
   * @generated from field: gitpod.v1.Subject creator = 4;
   */
  creator?: Subject;

  /**
   * @generated from field: gitpod.v1.Subject executor = 5;
   */
  executor?: Subject;
};

/**
 * Describes the message gitpod.v1.WorkflowExecution.Metadata.
 * Use `create(WorkflowExecution_MetadataSchema)` to create a new message.
 */
export const WorkflowExecution_MetadataSchema: GenMessage<WorkflowExecution_Metadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 34, 0);

/**
 * WorkflowExecutionSpec contains the specification used for this execution.
 *
 * @generated from message gitpod.v1.WorkflowExecution.Spec
 */
export type WorkflowExecution_Spec = Message<"gitpod.v1.WorkflowExecution.Spec"> & {
  /**
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionPhase desired_phase = 2;
   */
  desiredPhase: WorkflowExecutionPhase;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionTrigger trigger = 3;
   */
  trigger?: WorkflowExecutionTrigger;

  /**
   * @generated from field: gitpod.v1.WorkflowAction action = 4;
   */
  action?: WorkflowAction;

  /**
   * @generated from field: gitpod.v1.WorkflowAction report = 5;
   */
  report?: WorkflowAction;
};

/**
 * Describes the message gitpod.v1.WorkflowExecution.Spec.
 * Use `create(WorkflowExecution_SpecSchema)` to create a new message.
 */
export const WorkflowExecution_SpecSchema: GenMessage<WorkflowExecution_Spec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 34, 1);

/**
 * WorkflowExecutionStatus contains the current status of a workflow execution.
 *
 * @generated from message gitpod.v1.WorkflowExecution.Status
 */
export type WorkflowExecution_Status = Message<"gitpod.v1.WorkflowExecution.Status"> & {
  /**
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionPhase phase = 2;
   */
  phase: WorkflowExecutionPhase;

  /**
   * @generated from field: int32 pending_action_count = 10;
   */
  pendingActionCount: number;

  /**
   * @generated from field: int32 running_action_count = 11;
   */
  runningActionCount: number;

  /**
   * @generated from field: int32 failed_action_count = 12;
   */
  failedActionCount: number;

  /**
   * @generated from field: int32 done_action_count = 13;
   */
  doneActionCount: number;

  /**
   * @generated from field: int32 stopped_action_count = 18;
   */
  stoppedActionCount: number;

  /**
   * FailureMessage summarises why the workflow execution failed to operate. If this is non-empty
   * the workflow execution has failed to operate and will likely transition to a stopped state.
   * Deprecated: Use errors field instead for structured error information.
   *
   * @generated from field: string failure_message = 14;
   */
  failureMessage: string;

  /**
   * WarningMessage summarises why the workflow execution is in a warning state. If this is non-empty
   * the workflow execution is in a warning state and likely does not match the users expectations.
   * Deprecated: Use warnings field instead for structured warning information.
   *
   * @generated from field: string warning_message = 15;
   */
  warningMessage: string;

  /**
   * Structured failures that caused the workflow execution to fail.
   * Provides detailed error codes, messages, and retry information.
   *
   * @generated from field: repeated gitpod.v1.WorkflowError failures = 16;
   */
  failures: WorkflowError[];

  /**
   * Structured warnings about the workflow execution.
   * Provides detailed warning codes and messages.
   *
   * @generated from field: repeated gitpod.v1.WorkflowError warnings = 17;
   */
  warnings: WorkflowError[];
};

/**
 * Describes the message gitpod.v1.WorkflowExecution.Status.
 * Use `create(WorkflowExecution_StatusSchema)` to create a new message.
 */
export const WorkflowExecution_StatusSchema: GenMessage<WorkflowExecution_Status> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 34, 2);

/**
 * WorkflowExecutionAction represents a workflow execution action instance.
 *
 * @generated from message gitpod.v1.WorkflowExecutionAction
 */
export type WorkflowExecutionAction = Message<"gitpod.v1.WorkflowExecutionAction"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionAction.Metadata metadata = 2;
   */
  metadata?: WorkflowExecutionAction_Metadata;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionAction.Spec spec = 3;
   */
  spec?: WorkflowExecutionAction_Spec;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionAction.Status status = 4;
   */
  status?: WorkflowExecutionAction_Status;
};

/**
 * Describes the message gitpod.v1.WorkflowExecutionAction.
 * Use `create(WorkflowExecutionActionSchema)` to create a new message.
 */
export const WorkflowExecutionActionSchema: GenMessage<WorkflowExecutionAction> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 35);

/**
 * WorkflowExecutionActionMetadata contains workflow execution action metadata.
 *
 * @generated from message gitpod.v1.WorkflowExecutionAction.Metadata
 */
export type WorkflowExecutionAction_Metadata = Message<"gitpod.v1.WorkflowExecutionAction.Metadata"> & {
  /**
   * @generated from field: string workflow_execution_id = 1;
   */
  workflowExecutionId: string;

  /**
   * @generated from field: string workflow_id = 2;
   */
  workflowId: string;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 3;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 4;
   */
  finishedAt?: Timestamp;

  /**
   * Human-readable name for this action based on its context.
   * Examples: "gitpod-io/gitpod-next" for repository context, "My Project" for project context.
   * Will be empty string for actions created before this field was added.
   *
   * @generated from field: string action_name = 5;
   */
  actionName: string;
};

/**
 * Describes the message gitpod.v1.WorkflowExecutionAction.Metadata.
 * Use `create(WorkflowExecutionAction_MetadataSchema)` to create a new message.
 */
export const WorkflowExecutionAction_MetadataSchema: GenMessage<WorkflowExecutionAction_Metadata> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 35, 0);

/**
 * WorkflowExecutionActionSpec contains the specification for this execution action.
 *
 * @generated from message gitpod.v1.WorkflowExecutionAction.Spec
 */
export type WorkflowExecutionAction_Spec = Message<"gitpod.v1.WorkflowExecutionAction.Spec"> & {
  /**
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionActionPhase desired_phase = 2;
   */
  desiredPhase: WorkflowExecutionActionPhase;

  /**
   * Context for the execution action - specifies where and how the action executes.
   * This is resolved from the workflow trigger context and contains the specific
   * project, repository, or agent context for this execution instance.
   *
   * @generated from field: gitpod.v1.AgentCodeContext context = 3;
   */
  context?: AgentCodeContext;

  /**
   * @generated from field: gitpod.v1.WorkflowAction.Limits.PerExecution limits = 4;
   */
  limits?: WorkflowAction_Limits_PerExecution;
};

/**
 * Describes the message gitpod.v1.WorkflowExecutionAction.Spec.
 * Use `create(WorkflowExecutionAction_SpecSchema)` to create a new message.
 */
export const WorkflowExecutionAction_SpecSchema: GenMessage<WorkflowExecutionAction_Spec> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 35, 1);

/**
 * WorkflowExecutionActionStatus contains the current status of a workflow execution action.
 *
 * @generated from message gitpod.v1.WorkflowExecutionAction.Status
 */
export type WorkflowExecutionAction_Status = Message<"gitpod.v1.WorkflowExecutionAction.Status"> & {
  /**
   * @generated from field: string session = 1;
   */
  session: string;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionActionPhase phase = 2;
   */
  phase: WorkflowExecutionActionPhase;

  /**
   * Step-level progress tracking
   *
   * @generated from field: repeated gitpod.v1.WorkflowExecutionAction.Status.StepStatus step_statuses = 3;
   */
  stepStatuses: WorkflowExecutionAction_Status_StepStatus[];

  /**
   * @generated from field: string environment_id = 10;
   */
  environmentId: string;

  /**
   * @generated from field: string agent_execution_id = 12;
   */
  agentExecutionId: string;

  /**
   * FailureMessage summarises why the workflow execution action failed to operate. If this is non-empty
   * the workflow execution action has failed to operate and will likely transition to a stopped state.
   * Deprecated: Use errors field instead for structured error information.
   *
   * @generated from field: string failure_message = 11;
   */
  failureMessage: string;

  /**
   * WarningMessage summarises why the workflow execution action is in a warning state. If this is non-empty
   * the workflow execution action is in a warning state and likely does not match the users expectations.
   * Deprecated: Use warnings field instead for structured warning information.
   *
   * @generated from field: string warning_message = 13;
   */
  warningMessage: string;

  /**
   * Structured failures that caused the workflow execution action to fail.
   * Provides detailed error codes, messages, and retry information.
   *
   * @generated from field: repeated gitpod.v1.WorkflowError failures = 14;
   */
  failures: WorkflowError[];

  /**
   * Structured warnings about the workflow execution action.
   * Provides detailed warning codes and messages.
   *
   * @generated from field: repeated gitpod.v1.WorkflowError warnings = 15;
   */
  warnings: WorkflowError[];
};

/**
 * Describes the message gitpod.v1.WorkflowExecutionAction.Status.
 * Use `create(WorkflowExecutionAction_StatusSchema)` to create a new message.
 */
export const WorkflowExecutionAction_StatusSchema: GenMessage<WorkflowExecutionAction_Status> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 35, 2);

/**
 * WorkflowExecutionActionStepStatus represents the status of a single step execution.
 *
 * @generated from message gitpod.v1.WorkflowExecutionAction.Status.StepStatus
 */
export type WorkflowExecutionAction_Status_StepStatus = Message<"gitpod.v1.WorkflowExecutionAction.Status.StepStatus"> & {
  /**
   * Index of the step in the workflow action steps array
   *
   * @generated from field: int32 step_index = 1;
   */
  stepIndex: number;

  /**
   * @generated from field: gitpod.v1.WorkflowExecutionAction.Status.StepStatus.StepPhase phase = 2;
   */
  phase: WorkflowExecutionAction_Status_StepStatus_StepPhase;

  /**
   * Deprecated: Use error field instead for structured error information.
   *
   * @generated from field: string failure_message = 3;
   */
  failureMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 4;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 5;
   */
  finishedAt?: Timestamp;

  /**
   * The step definition captured at execution time for immutability.
   * This ensures the UI shows the correct step even if the workflow definition changes.
   *
   * @generated from field: gitpod.v1.WorkflowStep step = 6;
   */
  step?: WorkflowStep;

  /**
   * Structured error that caused the step to fail.
   * Provides detailed error code, message, and retry information.
   *
   * @generated from field: gitpod.v1.WorkflowError error = 7;
   */
  error?: WorkflowError;
};

/**
 * Describes the message gitpod.v1.WorkflowExecutionAction.Status.StepStatus.
 * Use `create(WorkflowExecutionAction_Status_StepStatusSchema)` to create a new message.
 */
export const WorkflowExecutionAction_Status_StepStatusSchema: GenMessage<WorkflowExecutionAction_Status_StepStatus> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 35, 2, 0);

/**
 * @generated from enum gitpod.v1.WorkflowExecutionAction.Status.StepStatus.StepPhase
 */
export enum WorkflowExecutionAction_Status_StepStatus_StepPhase {
  /**
   * @generated from enum value: STEP_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: STEP_PHASE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: STEP_PHASE_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: STEP_PHASE_DONE = 3;
   */
  DONE = 3,

  /**
   * @generated from enum value: STEP_PHASE_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: STEP_PHASE_CANCELLED = 5;
   */
  CANCELLED = 5,
}

/**
 * Describes the enum gitpod.v1.WorkflowExecutionAction.Status.StepStatus.StepPhase.
 */
export const WorkflowExecutionAction_Status_StepStatus_StepPhaseSchema: GenEnum<WorkflowExecutionAction_Status_StepStatus_StepPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_workflow, 35, 2, 0, 0);

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionOutputsRequest
 */
export type ListWorkflowExecutionOutputsRequest = Message<"gitpod.v1.ListWorkflowExecutionOutputsRequest"> & {
  /**
   * @generated from field: gitpod.v1.PaginationRequest pagination = 1;
   */
  pagination?: PaginationRequest;

  /**
   * @generated from field: gitpod.v1.ListWorkflowExecutionOutputsRequest.Filter filter = 2;
   */
  filter?: ListWorkflowExecutionOutputsRequest_Filter;
};

/**
 * Describes the message gitpod.v1.ListWorkflowExecutionOutputsRequest.
 * Use `create(ListWorkflowExecutionOutputsRequestSchema)` to create a new message.
 */
export const ListWorkflowExecutionOutputsRequestSchema: GenMessage<ListWorkflowExecutionOutputsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 36);

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionOutputsRequest.Filter
 */
export type ListWorkflowExecutionOutputsRequest_Filter = Message<"gitpod.v1.ListWorkflowExecutionOutputsRequest.Filter"> & {
  /**
   * @generated from field: repeated string workflow_execution_ids = 1;
   */
  workflowExecutionIds: string[];
};

/**
 * Describes the message gitpod.v1.ListWorkflowExecutionOutputsRequest.Filter.
 * Use `create(ListWorkflowExecutionOutputsRequest_FilterSchema)` to create a new message.
 */
export const ListWorkflowExecutionOutputsRequest_FilterSchema: GenMessage<ListWorkflowExecutionOutputsRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 36, 0);

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionOutputsResponse
 */
export type ListWorkflowExecutionOutputsResponse = Message<"gitpod.v1.ListWorkflowExecutionOutputsResponse"> & {
  /**
   * @generated from field: gitpod.v1.PaginationResponse pagination = 1;
   */
  pagination?: PaginationResponse;

  /**
   * @generated from field: repeated gitpod.v1.ListWorkflowExecutionOutputsResponse.ActionOutput outputs = 2;
   */
  outputs: ListWorkflowExecutionOutputsResponse_ActionOutput[];
};

/**
 * Describes the message gitpod.v1.ListWorkflowExecutionOutputsResponse.
 * Use `create(ListWorkflowExecutionOutputsResponseSchema)` to create a new message.
 */
export const ListWorkflowExecutionOutputsResponseSchema: GenMessage<ListWorkflowExecutionOutputsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 37);

/**
 * @generated from message gitpod.v1.ListWorkflowExecutionOutputsResponse.ActionOutput
 */
export type ListWorkflowExecutionOutputsResponse_ActionOutput = Message<"gitpod.v1.ListWorkflowExecutionOutputsResponse.ActionOutput"> & {
  /**
   * @generated from field: string action_id = 1;
   */
  actionId: string;

  /**
   * @generated from field: map<string, gitpod.v1.AgentExecution.Status.OutputValue> values = 2;
   */
  values: { [key: string]: AgentExecution_Status_OutputValue };
};

/**
 * Describes the message gitpod.v1.ListWorkflowExecutionOutputsResponse.ActionOutput.
 * Use `create(ListWorkflowExecutionOutputsResponse_ActionOutputSchema)` to create a new message.
 */
export const ListWorkflowExecutionOutputsResponse_ActionOutputSchema: GenMessage<ListWorkflowExecutionOutputsResponse_ActionOutput> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 37, 0);

/**
 * GetWorkflowExecutionSummaryRequest returns aggregate counts of workflow executions.
 *
 * @generated from message gitpod.v1.GetWorkflowExecutionSummaryRequest
 */
export type GetWorkflowExecutionSummaryRequest = Message<"gitpod.v1.GetWorkflowExecutionSummaryRequest"> & {
  /**
   * @generated from field: gitpod.v1.GetWorkflowExecutionSummaryRequest.Filter filter = 1;
   */
  filter?: GetWorkflowExecutionSummaryRequest_Filter;
};

/**
 * Describes the message gitpod.v1.GetWorkflowExecutionSummaryRequest.
 * Use `create(GetWorkflowExecutionSummaryRequestSchema)` to create a new message.
 */
export const GetWorkflowExecutionSummaryRequestSchema: GenMessage<GetWorkflowExecutionSummaryRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 38);

/**
 * @generated from message gitpod.v1.GetWorkflowExecutionSummaryRequest.Filter
 */
export type GetWorkflowExecutionSummaryRequest_Filter = Message<"gitpod.v1.GetWorkflowExecutionSummaryRequest.Filter"> & {
  /**
   * Date range to query executions within.
   *
   * @generated from field: gitpod.v1.DateRange date_range = 1;
   */
  dateRange?: DateRange;

  /**
   * Optional workflow IDs to scope the summary to specific workflows.
   *
   * @generated from field: repeated string workflow_ids = 2;
   */
  workflowIds: string[];
};

/**
 * Describes the message gitpod.v1.GetWorkflowExecutionSummaryRequest.Filter.
 * Use `create(GetWorkflowExecutionSummaryRequest_FilterSchema)` to create a new message.
 */
export const GetWorkflowExecutionSummaryRequest_FilterSchema: GenMessage<GetWorkflowExecutionSummaryRequest_Filter> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 38, 0);

/**
 * @generated from message gitpod.v1.GetWorkflowExecutionSummaryResponse
 */
export type GetWorkflowExecutionSummaryResponse = Message<"gitpod.v1.GetWorkflowExecutionSummaryResponse"> & {
  /**
   * Number of executions in COMPLETED phase with no failed actions (failed_action_count == 0).
   *
   * @generated from field: int64 successful_count = 1;
   */
  successfulCount: bigint;

  /**
   * Number of failed executions: COMPLETED with failed_action_count > 0, or STOPPED with
   * failed_action_count > 0 or a non-empty failure_message (matches dashboard "Failed" labeling).
   *
   * @generated from field: int64 failed_count = 2;
   */
  failedCount: bigint;

  /**
   * Total number of executions in the time range, regardless of phase.
   *
   * @generated from field: int64 total_count = 3;
   */
  totalCount: bigint;

  /**
   * Total number of workflows that exist in the organization.
   * This count is independent of the date range filter.
   *
   * @generated from field: int64 total_workflows_in_organization = 4;
   */
  totalWorkflowsInOrganization: bigint;
};

/**
 * Describes the message gitpod.v1.GetWorkflowExecutionSummaryResponse.
 * Use `create(GetWorkflowExecutionSummaryResponseSchema)` to create a new message.
 */
export const GetWorkflowExecutionSummaryResponseSchema: GenMessage<GetWorkflowExecutionSummaryResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_workflow, 39);

/**
 * @generated from enum gitpod.v1.WorkflowExecutionPhase
 */
export enum WorkflowExecutionPhase {
  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_STOPPING = 3;
   */
  STOPPING = 3,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_STOPPED = 4;
   */
  STOPPED = 4,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_DELETING = 5;
   */
  DELETING = 5,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_DELETED = 6;
   */
  DELETED = 6,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_PHASE_COMPLETED = 7;
   */
  COMPLETED = 7,
}

/**
 * Describes the enum gitpod.v1.WorkflowExecutionPhase.
 */
export const WorkflowExecutionPhaseSchema: GenEnum<WorkflowExecutionPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_workflow, 0);

/**
 * WorkflowExecutionActionPhase defines the phases of workflow execution action.
 *
 * @generated from enum gitpod.v1.WorkflowExecutionActionPhase
 */
export enum WorkflowExecutionActionPhase {
  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_STOPPING = 3;
   */
  STOPPING = 3,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_STOPPED = 4;
   */
  STOPPED = 4,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_DELETING = 5;
   */
  DELETING = 5,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_DELETED = 6;
   */
  DELETED = 6,

  /**
   * @generated from enum value: WORKFLOW_EXECUTION_ACTION_PHASE_DONE = 7;
   */
  DONE = 7,
}

/**
 * Describes the enum gitpod.v1.WorkflowExecutionActionPhase.
 */
export const WorkflowExecutionActionPhaseSchema: GenEnum<WorkflowExecutionActionPhase> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_workflow, 1);

/**
 * @generated from service gitpod.v1.WorkflowService
 */
export const WorkflowService: GenService<{
  /**
   * Creates a new workflow with specified configuration.
   *
   * Use this method to:
   * - Set up automated workflows
   * - Configure workflow triggers
   * - Define workflow actions and steps
   * - Set execution limits and constraints
   *
   * @generated from rpc gitpod.v1.WorkflowService.CreateWorkflow
   */
  createWorkflow: {
    methodKind: "unary";
    input: typeof CreateWorkflowRequestSchema;
    output: typeof CreateWorkflowResponseSchema;
  },
  /**
   * Gets details about a specific workflow.
   *
   * Use this method to:
   * - View workflow configuration
   * - Check workflow status
   * - Get workflow metadata
   *
   * ### Examples
   *
   * - Get workflow details:
   *
   *   Retrieves information about a specific workflow.
   *
   *   ```yaml
   *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.GetWorkflow
   */
  getWorkflow: {
    methodKind: "unary";
    input: typeof GetWorkflowRequestSchema;
    output: typeof GetWorkflowResponseSchema;
  },
  /**
   * Updates a workflow's configuration using full replacement semantics.
   *
   * Update Behavior:
   * - All provided fields completely replace existing values
   * - Optional fields that are not provided remain unchanged
   * - Complex fields (triggers, action) are replaced entirely, not merged
   * - To remove optional fields, explicitly set them to empty/default values
   *
   * Use this method to:
   * - Modify workflow settings
   * - Update triggers and actions
   * - Change execution limits
   * - Update workflow steps
   *
   * ### Examples
   *
   * - Update workflow name:
   *
   *   Changes the workflow's display name.
   *
   *   ```yaml
   *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   name: "Updated Workflow Name"
   *   ```
   *
   * - Replace all triggers:
   *
   *   Completely replaces the workflow's trigger configuration.
   *
   *   ```yaml
   *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   triggers:
   *     - manual: {}
   *       context:
   *         projects:
   *           projectIds: ["new-project-id"]
   *   ```
   *
   * - Update execution limits:
   *
   *   Completely replaces the workflow's action configuration.
   *
   *   ```yaml
   *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   action:
   *     limits:
   *       maxParallel: 10
   *       maxTotal: 100
   *     steps:
   *       - task:
   *           command: "npm test"
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.UpdateWorkflow
   */
  updateWorkflow: {
    methodKind: "unary";
    input: typeof UpdateWorkflowRequestSchema;
    output: typeof UpdateWorkflowResponseSchema;
  },
  /**
   * @generated from rpc gitpod.v1.WorkflowService.ListWorkflows
   */
  listWorkflows: {
    methodKind: "unary";
    input: typeof ListWorkflowsRequestSchema;
    output: typeof ListWorkflowsResponseSchema;
  },
  /**
   * Deletes a workflow permanently.
   *
   * Use this method to:
   * - Remove unused workflows
   * - Clean up test workflows
   * - Delete obsolete configurations
   *
   * ### Examples
   *
   * - Delete workflow:
   *
   *   Permanently removes a workflow.
   *
   *   ```yaml
   *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.DeleteWorkflow
   */
  deleteWorkflow: {
    methodKind: "unary";
    input: typeof DeleteWorkflowRequestSchema;
    output: typeof DeleteWorkflowResponseSchema;
  },
  /**
   * Starts a workflow execution.
   *
   * Use this method to:
   * - Start workflow execution on demand
   * - Test workflow configurations
   * - Run workflows outside of automatic triggers
   *
   * ### Examples
   *
   * - Start workflow:
   *
   *   Starts a workflow execution manually.
   *
   *   ```yaml
   *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.StartWorkflow
   */
  startWorkflow: {
    methodKind: "unary";
    input: typeof StartWorkflowRequestSchema;
    output: typeof StartWorkflowResponseSchema;
  },
  /**
   * Lists workflow executions with optional filtering.
   *
   * Use this method to:
   * - Monitor workflow execution history
   * - Track execution status
   * - Debug workflow issues
   *
   * ### Examples
   *
   * - List executions for workflow:
   *
   *   Shows all executions for a specific workflow.
   *
   *   ```yaml
   *   filter:
   *     workflowIds: ["b0e12f6c-4c67-429d-a4a6-d9838b5da047"]
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.ListWorkflowExecutions
   */
  listWorkflowExecutions: {
    methodKind: "unary";
    input: typeof ListWorkflowExecutionsRequestSchema;
    output: typeof ListWorkflowExecutionsResponseSchema;
  },
  /**
   * Gets details about a specific workflow execution.
   *
   * Use this method to:
   * - Check execution status
   * - View execution results
   * - Monitor execution progress
   *
   * ### Examples
   *
   * - Get execution details:
   *
   *   Retrieves information about a specific execution.
   *
   *   ```yaml
   *   workflowExecutionId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.GetWorkflowExecution
   */
  getWorkflowExecution: {
    methodKind: "unary";
    input: typeof GetWorkflowExecutionRequestSchema;
    output: typeof GetWorkflowExecutionResponseSchema;
  },
  /**
   * Cancels a running workflow execution.
   *
   * Use this method to:
   * - Stop long-running executions
   * - Cancel failed executions
   * - Manage resource usage
   *
   * ### Examples
   *
   * - Cancel execution:
   *
   *   Stops a running workflow execution.
   *
   *   ```yaml
   *   workflowExecutionId: "d2c94c27-3b76-4a42-b88c-95a85e392c68"
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.CancelWorkflowExecution
   */
  cancelWorkflowExecution: {
    methodKind: "unary";
    input: typeof CancelWorkflowExecutionRequestSchema;
    output: typeof CancelWorkflowExecutionResponseSchema;
  },
  /**
   * Lists workflow execution actions with optional filtering.
   *
   * Use this method to:
   * - Monitor individual action execution status
   * - Debug action failures
   * - Track resource usage per action
   *
   * ### Examples
   *
   * - List execution actions for workflow execution:
   *
   *   Shows all execution actions for a specific workflow execution.
   *
   *   ```yaml
   *   filter:
   *     workflowExecutionIds: ["d2c94c27-3b76-4a42-b88c-95a85e392c68"]
   *   pagination:
   *     pageSize: 20
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.ListWorkflowExecutionActions
   */
  listWorkflowExecutionActions: {
    methodKind: "unary";
    input: typeof ListWorkflowExecutionActionsRequestSchema;
    output: typeof ListWorkflowExecutionActionsResponseSchema;
  },
  /**
   * Lists outputs produced by workflow execution actions.
   *
   * Use this method to:
   * - Retrieve test results, coverage metrics, or other structured data from executions
   * - Aggregate outputs across multiple workflow executions
   * - Build dashboards or reports from execution data
   *
   * ### Examples
   *
   * - List outputs for a workflow execution:
   *
   *   Retrieves all outputs produced by actions in the specified execution.
   *
   *   ```yaml
   *   filter:
   *     workflowExecutionIds: ["d2c94c27-3b76-4a42-b88c-95a85e392c68"]
   *   pagination:
   *     pageSize: 50
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.ListWorkflowExecutionOutputs
   */
  listWorkflowExecutionOutputs: {
    methodKind: "unary";
    input: typeof ListWorkflowExecutionOutputsRequestSchema;
    output: typeof ListWorkflowExecutionOutputsResponseSchema;
  },
  /**
   * Gets details about a specific workflow execution action.
   *
   * Use this method to:
   * - Check execution action status
   * - View execution action results
   * - Monitor execution action progress
   *
   * ### Examples
   *
   * - Get execution action details:
   *
   *   Retrieves information about a specific execution action.
   *
   *   ```yaml
   *   workflowExecutionActionId: "a1b2c3d4-5e6f-7890-abcd-ef1234567890"
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.GetWorkflowExecutionAction
   */
  getWorkflowExecutionAction: {
    methodKind: "unary";
    input: typeof GetWorkflowExecutionActionRequestSchema;
    output: typeof GetWorkflowExecutionActionResponseSchema;
  },
  /**
   * Cancels a running workflow execution action.
   *
   * Use this method to:
   * - Stop long-running actions
   * - Cancel failed actions
   * - Manage resource usage
   *
   * ### Examples
   *
   * - Cancel execution action:
   *
   *   Stops a running workflow execution action.
   *
   *   ```yaml
   *   workflowExecutionActionId: "a1b2c3d4-5e6f-7890-abcd-ef1234567890"
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.CancelWorkflowExecutionAction
   */
  cancelWorkflowExecutionAction: {
    methodKind: "unary";
    input: typeof CancelWorkflowExecutionActionRequestSchema;
    output: typeof CancelWorkflowExecutionActionResponseSchema;
  },
  /**
   * Gets the webhook secret for a workflow.
   *
   * This operation is audited for security purposes.
   *
   * Use this method to:
   * - Retrieve webhook secret for configuration
   * - Set up webhook integrations
   * - Verify webhook signatures
   *
   * ### Examples
   *
   * - Get webhook secret:
   *
   *   Retrieves the webhook secret for a workflow.
   *
   *   ```yaml
   *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.GetWorkflowWebhookSecret
   */
  getWorkflowWebhookSecret: {
    methodKind: "unary";
    input: typeof GetWorkflowWebhookSecretRequestSchema;
    output: typeof GetWorkflowWebhookSecretResponseSchema;
  },
  /**
   * Rotates the webhook secret for a workflow.
   *
   * Use this method to:
   * - Generate a new webhook secret
   * - Invalidate the old webhook secret
   *
   * ### Examples
   *
   * - Rotate webhook secret:
   *
   *   Generates a new webhook secret for the workflow.
   *
   *   ```yaml
   *   workflowId: "b0e12f6c-4c67-429d-a4a6-d9838b5da047"
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.RotateWorkflowWebhookSecret
   */
  rotateWorkflowWebhookSecret: {
    methodKind: "unary";
    input: typeof RotateWorkflowWebhookSecretRequestSchema;
    output: typeof RotateWorkflowWebhookSecretResponseSchema;
  },
  /**
   * Returns aggregate counts of workflow executions within a time range.
   *
   * Use this method to:
   * - Get a summary of successful, failed, and total executions
   * - Build dashboard views of automation activity
   *
   * ### Examples
   *
   * - Get execution summary for the last 7 days:
   *
   *   ```yaml
   *   filter:
   *     dateRange:
   *       startTime: "2026-03-05T00:00:00Z"
   *       endTime: "2026-03-12T00:00:00Z"
   *   ```
   *
   * - Get execution summary for specific workflows:
   *
   *   ```yaml
   *   filter:
   *     dateRange:
   *       startTime: "2026-03-01T00:00:00Z"
   *       endTime: "2026-03-12T00:00:00Z"
   *     workflowIds: ["b0e12f6c-4c67-429d-a4a6-d9838b5da047"]
   *   ```
   *
   * @generated from rpc gitpod.v1.WorkflowService.GetWorkflowExecutionSummary
   */
  getWorkflowExecutionSummary: {
    methodKind: "unary";
    input: typeof GetWorkflowExecutionSummaryRequestSchema;
    output: typeof GetWorkflowExecutionSummaryResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_workflow, 0);

